import React from 'react';
import {
    Text,
} from '@chakra-ui/react';

export function TextoInicioMapa(){

    return(
        <>
            <Text ml={2}>
                Algunos de los lugares que he visitado
            </Text>
        </>
    )
}
